module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_Badges_116x116_6-ba142de5cedf705391f5789f460a4cd2.png";